import { render, staticRenderFns } from "./NewChannel.view.vue?vue&type=template&id=1f4036e8&"
import script from "./NewChannel.view.vue?vue&type=script&lang=js&"
export * from "./NewChannel.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports